import root from '../root';

/**
 * Creates a throttled function that only invokes `listener` at most once
 * per every `delay` milliseconds.
 *
 * @see
 * https://css-tricks.com/debouncing-throttling-explained-examples/
 * https://remysharp.com/2010/07/21/throttling-function-calls
 *
 * @param {Function} listener - the event handler to call upon the event triggered
 * @param {Number} delay - the number of milliseconds to throttle the listener
 * @param {Function} forceInmediatePropagation - custom function to restart the throttle timer.
 * @returns {Function}
 */
export default function throttle(listener, delay, forceInmediatePropagation) {
  let timer = null,
    result;

  const cbTimeout = () => {
    // TODO: ensure re-invoke last listener
    root.clearTimeout(timer);
    timer = null;
  };

  // generator function pattern
  return function throttledListener(evt, ...args) {
    const context = this;
    if (timer != null && (typeof forceInmediatePropagation !== 'function' || !forceInmediatePropagation(evt))) {
      evt.stopImmediatePropagation();
      return result;
    }
    result = listener.apply(context, [].concat(evt, args));
    timer = root.setTimeout(cbTimeout, delay);
    return result;
  };
}
